<div class="panel panel-default" *ngIf="order">
  <div class="panel-body">
    <lh-simple-order-summary
      [headline]="'RECEIPT' | translate"
      [isPaid]="true"
      [isCanceled]="booking.status === 'CANCELLED'"
      [order]="order"
      [isReadOnly]="true"
      [isInfoEnabled]="false"
      [noPadding]="true"
      [totalNote]="totalNote"
    ></lh-simple-order-summary>
  </div>
</div>
